module.exports = __webpack_public_path__ + "img/js-music.041638f7.png";